module.exports = __webpack_public_path__ + "static/media/1_reported_post_icon.14dfb4d8.svg";